<template>
  <div id="container">
    <div class="product-status">
      <div class="bold"></div>
      <div style="position: absolute;top:10px;right:20px;z-index: 99">
        <div>
          <el-checkbox
            v-model="checked"
            style="padding-left:16px;"
          >每60秒刷新当前页面
          </el-checkbox>
        </div>
      </div>
      <el-tabs
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="(item,index) in bankCollectionList"
          :key="index"
        >
        </el-tab-pane>
      </el-tabs>
      <finance-seach
        :column-option="otherCollectionOptionList"
        :timer-array="['processDate']"
        @onSearch="getList"
        ref="clearSeachInfo"
      >
        <div
          class="search_rightitem"
          v-show="activeName==='1' || activeName==='2'"
        >
          <el-form-item>
            <el-button
              type="primary"
              v-show="activeName==='1'"
              :disabled="!list.length"
              @click="MassClaim"
            >批量领取
            </el-button>
            <el-button
              type="primary"
              v-show="activeName === '2'"
              :disabled="!list.length"
            >批量通过
            </el-button>
          </el-form-item>
        </div>
      </finance-seach>
      <div
        class="box-table"
        :style="{height: financeTableHeight + 'px'}"
      >
        <el-row
          style="margin-bottom:20px;"
          v-if="activeName ==='收款记录'"
        >
          <el-col :span="4">待审核付款申请：<span style="color:#D35E5E;">{{total}}条</span></el-col>
          <el-col :span="4">
            付款总额：
            <span style="color:#D35E5E;">{{ totalPrice | showPrice}}元</span>
          </el-col>
        </el-row>
        <el-table
          border
          type="reset"
          ref="tableRef"
          :data="list"
          :max-height="financeTableHeight"
          tooltip-effect="dark"
          :header-cell-style="tableHeader"
          v-loading="loadingTable"
          element-loading-text="拼命加载中请稍后..."
          element-loading-spinner="el-icon-loading"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            type="selection"
            width="55"
            :key="1"
            :selectable="selectableFun"
            v-if="activeName === '1'"
          ></el-table-column>

          <el-table-column
            prop="receiptNumber"
            :key="2"
            label="收款编号"
            v-if="activeName !== '5'"
          >
            <template slot-scope="scope">
              <span
                class="approval"
                @click="onDetails(scope.row)"
              >{{scope.row.receiptNumber}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :key="3"
            prop="receiptNumber"
            label="收款编号"
            v-else
          ></el-table-column>
          <el-table-column
            :key="4"
            prop="suName"
            label="供应商名称"
          >
            <template slot-scope="scope">
              <span class="approval"
                    @click="goSulipper(scope.row)">{{scope.row.suName}}</span>
            </template>
          </el-table-column>
          <el-table-column
            :key="5"
            prop="payBankNumber"
            label="付款人银行账号"
          ></el-table-column>
          <el-table-column
            :key="6"
            prop=""
            label="付款人名称"
            v-if="activeName==='我的已审核'"
          ></el-table-column>
          <el-table-column
            :key="7"
            prop="payName"
            label="付款人名称"
          ></el-table-column>
          <el-table-column
            :key="8"
            prop="payOpenBank"
            label="开户行名称"
          ></el-table-column>
          <el-table-column
            :key="9"
            prop="payBankCode"
            label="银行行号"
          ></el-table-column>
          <el-table-column
            :key="10"
            prop="amount"
            label="收款金额"
          >
            <template v-slot="{row}">{{row.amount | toFixed}}</template>
          </el-table-column>
          <el-table-column
            :key="11"
            prop="receiptType"
            label="收款类型"
          ></el-table-column>
          <el-table-column
            :key="12"
            prop="receiptClass"
            label="收款方式"
          >
            <template>{{'银行转账'}}</template>
          </el-table-column>
          <el-table-column
            :key="13"
            prop="state"
            label="状态"
          >
            <template slot-scope="scope">
              <p>{{ scope.row.state | state }}</p>
            </template>
          </el-table-column>
          <el-table-column
            :key="14"
            prop="createUser"
            label="提交人"
          ></el-table-column>
          <el-table-column
            :key="15"
            prop="createDate"
            label="提交时间"
          >
            <template slot-scope="scope">{{
                                         scope.row.createDate | dateFilter
                                         }}
            </template>
          </el-table-column>
          <el-table-column
            prop="processUser"
            :key="16"
            label="认领人"
            v-if="activeName==='1'"
          ></el-table-column>
          <el-table-column
            prop="processUser"
            :key="17"
            label="处理人"
            v-if="activeName === '3' || activeName === '4'"
          ></el-table-column>
          <el-table-column
            prop="processDate"
            label="处理时间"
            :key="18"
            v-if="activeName ==='3' || activeName === '4'"
          >
            <template v-slot="{ row }">
              {{row.processDate | dateFilter}}
            </template>
          </el-table-column>
          <el-table-column
            prop="processDate"
            label="认领时间"
            :key="19"
            v-if="activeName ==='2' || activeName === '1'"
          >
            <template v-slot="{ row }">
              {{row.processDate | dateFilter}}
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            :key="20"
            v-if="activeName==='1'"
            prop='processState'
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="sureBtn(scope.row)"
                v-if="scope.row.extract === 1"
              >认领
              </el-button>
              <el-button
                type="text"
                @click="onExtract(scope.row)"
                v-if="scope.row.extract === 3"
              >提取
              </el-button>
              <el-button
                type="text"
                v-if="scope.row.extract === 2"
                @click="onHandle(scope.row)"
              >处理
              </el-button>
            </template>
          </el-table-column>
          <el-table-column
            fixed="right"
            label="操作"
            :key="21"
            v-if="activeName === '2'"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                prop="processState"
                @click="deleBtn(scope.row)"
              >处理
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <pagination
          :total="total"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        ></pagination>
      </div>
    </div>
    <!-- 弹框 -->
    <el-dialog
      title="确认提交"
      :visible.sync="dialogVisible"
      width="20%"
    >
      <span>确定认领？</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button
      type="primary"
      @click="sureBtn"
    >确 定</el-button>
  </span>
    </el-dialog>
    <el-dialog
      title="确认提交"
      :visible.sync="dialogVisibles"
      width="20%"
    >
      <span>确定提取？</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
    <el-button @click="dialogVisibles = false">取 消</el-button>
    <el-button
      type="primary"
      @click="subBtn"
    >确 定</el-button>
  </span>
    </el-dialog>

    <!-- 批量认领弹框 -->
    <el-dialog
      title="认领确认"
      :visible.sync="dialogVisiblesure"
      width="20%"
    >
      <div>总开票数：<span style="color:#D35E5E;">{{money.list.length}}</span>条; 开票总金额：<span style="color:#D35E5E;">{{money.count | count}}</span>
      </div>
      <span>确定认领开票申请？</span>
      <span
        slot="footer"
        class="dialog-footer"
      >
         <el-button
           type="primary"
           @click="misssurn"
         >确 定</el-button>
        <el-button @click="dialogVisiblesure = false">取 消</el-button>

      </span>
    </el-dialog>
  </div>
</template>
<script>
import { expressionList } from '@/components/utils/data'
import pagination from '@/components/pagination'
import {
  bankCollectionList,
  otherCollectionOptionList

} from '../financeManage/util/data'
import { queryListByState, updateStateByFbrIdupdata } from '@/api/fiance/fianceManage'
import { formatDate } from '@/util/tool'
import financeSeach from '@/components/module/financeSeach'
import { mapState } from 'vuex'
/*
   * 其他收款
   * updateStateByFbrIdExtract  提取
   * updateStateByFbrIdClaim  认领
   * updateStateByFbrIdClaimAll  批量认领
   * updateStateByFbrIdAll  批量通过
   * */

export default {
  components: {
    pagination: pagination,
    financeSeach
  },

  data () {
    return {
      money: {
        list: [],
        count: 0
      },
      miState: 0, // 列表状态
      activeName: '', // tabs选中状态
      bankCollectionList: bankCollectionList, // tabs状态
      loadingTable: false, // 列表loading
      totalPrice: 0, // 总价
      list: [], // 列表数据
      pageSize: 30, // 页数
      currentPage: 1, // 页码
      total: 0, // 列表总数
      queryParams: {}, // 搜索条件
      params: {},
      otherCollectionOptionList: otherCollectionOptionList, // 筛选条件
      expressionList: expressionList,
      dialogVisiblesure: false,
      checked: false,
      dialogVisible: false,
      dialogVisibles: false,
      value1: '',
      value2: '',
      state: '',
      id: ''
    }
  },
  mounted () {
    this.activeName = '1'
    this.getList()
  },
  filters: {
    count (count) {
      return count.toFixed(2)
    },
    showPrice (totalPrice) {
      return totalPrice.toFixed(2)
    },
    state (state) {
      if (state === 0) {
        return '未支付'
      } else if (state === 1) {
        return '确认收款'
      } else if (state === 2) {
        return '已认领（未处理）'
      } else if (state === 3) {
        return '已处理'
      }
    }
  },
  computed: {
    ...mapState(['financeTableHeight'])
  },
  watch: {
    checked (newVal) {
      clearInterval(this.timer)
      if (newVal) {
        this.timer = setInterval(() => {
          this.getList()
        }, 60000)
      }
      return newVal
    },
    activeName (newVal) {
      switch (newVal) {
        case '1':
          this.otherCollectionOptionList = [...otherCollectionOptionList,
            {
              label: '认领人',
              value: 'processSecUser'
            },
            {
              label: '认领时间',
              value: 'processSecDate'
            }]
          break
        case '2':
          this.otherCollectionOptionList = [...otherCollectionOptionList,
            {
              label: '认领时间',
              value: 'processSecDate'
            }]
          break
        case '3':
        case '4':
          this.otherCollectionOptionList = [...otherCollectionOptionList,
            {
              label: '处理人',
              value: 'processUser'
            },
            {
              label: '处理时间',
              value: 'processDate'
            }]
          break
      }
      return newVal
    }
  },
  methods: {
    onHandle (row) {
      this.$router.push({
        name: 'otherList',
        query: { fprsId: row.id }
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    dateFilter,
    // 重置
    searchReset () {
      this.params = {}
      this.queryParams = {}
      this.getList()
    },
    // 处理
    deleBtn (row) {
      this.$router.push({
        name: 'otherList',
        query: { fprsId: row.id }
      })
    },
    // 收款申请详情
    onDetails (row) {
      if (this.activeName === '收款记录') {
        this.$router.push({
          name: 'collectionDetails',
          query: { fprsId: row.id }
        })
      } else {
        this.$router.push({
          name: 'auditDetails',
          query: { fprsId: row.id }
        })
      }
    },
    goSulipper(row) {
      if (row.suId) {
        this.$router.push({
          path: '/crm/supplier/supplierEdit',
          query: { id: row.suId }
        })
      }
    },
    // 提取
    onExtract (row) {
      this.id = row.id

      this.processState = 1

      this.dialogVisibles = true
    },
    // 提交的确认
    subBtn () {
      const obj = [{
        processState: this.processState,
        state: this.state,
        id: this.id,
        mark: this.mark
      }]
      updateStateByFbrIdupdata(obj).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('提取成功！')
          this.loadingTable = false
        }
      })
        .catch((err) => {
          console.log(err)
        })

      this.dialogVisibles = false
    },
    // 批量领取
    MassClaim () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请选择一条或多条')
      } else {
        this.sureBtn(this.multipleSelection, false)
      }
    },
    misssurn () {
      this.dialogVisiblesure = false
    },
    // 认领
    onClaim (a) {
      this.sureBtn(a, true)
    },
    // 确认
    sureBtn (row, flag) {
      let obj = null
      if (flag) {
        obj = [...row]
      } else {
        obj = [row]
      }
      updateStateByFbrIdupdata(obj, {
        confirmState: 2
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message.success('认领成功！')
          this.loadingTable = false
          this.getList()
        }
      })
        .catch((err) => {
          console.log(err)
        })
      this.dialogVisible = false
    },
    // tabs切换时触发的事件
    handleClick (tab) {
      this.currentPage = 1
      this.activeName = tab.name
      this.$refs.clearSeachInfo.innerInit()
      this.getList()
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    // 列表数据
    getList (list) {
      this.loadingTable = true
      if (this.activeName === '1') {
        this.miState = 1
      } else if (this.activeName === '2') {
        this.miState = 2
      } else if (this.activeName === '3') {
        this.miState = 3
      } else if (this.activeName === '4') {
        this.miState = 4
      }
      const params = {
        criteriaVoList: list || [],
        queryPageName: ''
      }
      if (list) {
        this.currentPage = 1
      }
      queryListByState(this.miState, this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.totalPrice = 0
            this.loadingTable = false
            this.list = (res.data.obj.records[0] && res.data.obj.records[0].finaceAcceptanceReceiptList) || []
            this.list.forEach(ele => (this.totalPrice += ele.amount))
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    selectableFun (row) {
      return row.processState === 1
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    }
  }
}

function dateFilter (time) {
  const date = new Date(time)
  return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
}
</script>
<style
  lang="scss"
  scoped
>
</style>
